import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { reorderProduct } from '../Api'

export default generateApiAction({
  baseType: Types.PRODUCTS.REORDER,
  api: reorderProduct,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/products/ReorderAction.js